import React from "react";
import PropTypes from "prop-types";

import AddIcon from "../../../Common/components/Icons/Add/AddIcon";
import LessIcon from "../../../Common/components/Icons/LessIcon/LessIcon";

const AddDelControl = ({ title, onAdd, onDel, onDelDisabled, onAddDisabled }) => (
  <div className="flex flex-row items-center gap-2">
    <button
      type="button"
      className={`flex flex-col items-center justify-center w-5 h-5 rounded-full border
      ${!onDelDisabled ? " border-skyBlue bg-white" : "border-gray-400 bg-gray-400"}`}
      onClick={onDel}
      // disabled={onDelDisabled}
    >
      <LessIcon size={12} color={!onDelDisabled ? "#42B4E6" : "white"} />
    </button>
    <span className=" text-[#2F3136] font-normal text-sm text-center">{title}</span>
    <button
      type="button"
      className={`flex flex-col items-center justify-center w-5 h-5 rounded-full border
        ${!onAddDisabled ? " border-skyBlue bg-skyBlue" : "border-gray-400 bg-gray-400"}`}
      onClick={onAdd}
      // disabled={onAddDisabled}
    >
      <AddIcon size={12} color="white" />
    </button>
  </div>
);
AddDelControl.propTypes = {
  title: PropTypes.string,
  onAdd: PropTypes.func,
  onDel: PropTypes.func,
  onDelDisabled: PropTypes.bool,
  onAddDisabled: PropTypes.bool
};

AddDelControl.defaultProps = {
  title: "",
  onAdd: null,
  onDel: null,
  onDelDisabled: null,
  onAddDisabled: null
};
export default AddDelControl;
